module.exports = __webpack_public_path__ + "media/content-creator/beauty-2-8e7421e6.png";